// extracted by mini-css-extract-plugin
export default {"table":"styles_table__xJZeM","table__checkbox":"styles_table__checkbox__7S+1a"};